export const selectUserId = (state) => state.auth.userId;

export const selectAuth = (state) => state.auth;
